import Lang from 'ln/lang/Lang';
import DaybreakModel from '../models/DaybreakModel';
import CourseElement from './CourseElement';
import moment from 'moment';
import CoursePreview from './CoursePreview';

class DaybreakPreview extends CourseElement {

	constructor( public model:DaybreakModel, private courseView:CoursePreview ) {
		super( model, courseView );
	}
	
	public init() {
		super.init();
		
		// listen for changes
		this.renderTime(this.model.time);
		
		// listen for collapse/expand
		this.node.js( 'toggle' ).click.add( () => {
			this.courseView.toggleDaybreak( this.node );
		});
	}

	private renderTime(time:string) {
		let dispTime = moment( this.model.time, ['H:mm'] );
		this.node.one('.display-time').html = dispTime.format( 'H:mm' ) + ' ' + Lang.translate( 'processplan.time' );
	}
	
}

export default DaybreakPreview;